import { Injectable } from '@angular/core';
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '../session/app-session.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AppRouteGuard  {

  public constructor(
    private _permissionChecker: PermissionCheckerService,
    private _router: Router,
    private _sessionService: AppSessionService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (route.data && route.data['register'] && route.queryParams && route.queryParams['token']) {
      return true;
    }

    if (!this._sessionService.user) {
      this._router.navigate(['/account/login']).then();
      return false;
    }

    if (!route.data || !route.data['permission']) {
      return true;
    }

    // Check if the user has any of the listed permissions
    if (route.data['permission'].some(p => this._permissionChecker.isGranted(p))) {
      return true;
    }

    this._router.navigate([this.selectBestRoute()]);
    return false;
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  public selectBestRoute(): string {
    if (!this._sessionService.user) {
      return '/account/login';
    }

    if (this._permissionChecker.isGranted('Host.AccessDataManagementAdmin')) {
      return '/app/home';
    }

    if (this._permissionChecker.isGranted('Host.AccessDataManagement')) {
      return '/app/inspections';
    }

    if (this._permissionChecker.isGranted('Host.AccessDataManagementLimitedContractor')) {
      return '/app/inspections/search';
    }

    return '/account/unauthorized';
  }
}

@Injectable()
export class InspectionRouteGuard  {

  public constructor(
    private _permissionChecker: PermissionCheckerService,
    private _router: Router,
    private _sessionService: AppSessionService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this._sessionService.user) {
      this._router.navigate(['/account/login']).then();
      return false;
    }

    // Check if the user has any of the listed permissions
    if (route.data
      && route.data['permission']
      && route.data['permission'].some(p => this._permissionChecker.isGranted(p))) {
      return true;
    }

    this._router.navigate([this.selectBestRoute(state)]);
    return false;
  }

  public canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  public selectBestRoute(state: RouterStateSnapshot): string {
    if (!this._sessionService.user) {
      return '/account/login';
    }

    // Force the user out to the current Inspection's default/map page if they end up at a route that they don't have access to
    // Will push the user to the search page if the Inspection ID cannot be resolved
    if (!this._permissionChecker.isGranted('Host.AccessDataManagement')) {
      const inspectionRoute: String[] = state.url.replace('/app/inspections/', '').split('/');
      const inpsectionId: String = inspectionRoute.length > 0 ? inspectionRoute[0] : '';
      return '/app/inspections/' + inpsectionId;
    }
  }
}